<template>
    <form ref="uploadForm">
        <section class="image-wrapper">
            <div
                class="upload-image"
                v-for="(item, index) in imageList"
                :key="index"
                :style="{ backgroundImage: `url(${item})` }"
            >
                <div class="delete" v-if="item" @click="deleteImg(index)">
                    删除
                </div>
                <template v-if="index === imageList.length - 1">
                    <div v-if="!item">上传</div>

                    <input
                        v-if="!item"
                        class="upload-input"
                        type="file"
                        name="file"
                        :accept="accept"
                        :multiple="number && number > 1"
                        @change="changePicture"
                    />
                </template>
            </div>
            <div v-if="!imageList.length || number > 1" class="upload-image">
                <template >
                    <div>上传</div>

                    <input
                        class="upload-input"
                        type="file"
                        name="file"
                        :accept="accept"
                        :multiple="number && number > 1"
                        @change="changePicture"
                    />
                </template>
            </div>
        </section>
    </form>
</template>

<script>
import {
    upload
} from '@/api/common';
export default {
    data() {
        return {
            pictureName: '',
            imgSrc:
                Object.prototype.toString.call(this.value) === '[object String]'
                    ? this.value
                    : '',
            fileData: null,
            can: false,
            imageList: ['']
        };
    },

    props: {
        number: {
            type: Number,
            default: 1
        },
        tips: {
            type: String,
            default: '注：建议上传 150*150尺寸的图片，最大10M'
        },
        accept: {
            type: String,
            default: 'image/jpeg,image/jpg,image/png'
        },
        value: [String, Array],
        max: [Number, String],
        upload: Boolean
    },
    watch: {
        value(data) {
            if (!data) {
                this.imageList = [''];
            } else {
                this.initValue();
            }
        },
        imgSrc(val) {
            if (val) {
                this.can = true;
            }
        }
    },
    methods: {
        deleteImg(index) {
            if (this.number === 1) {
                this.imageList = [''];
                this.$emit('updateValue', '');
            } else {
                this.imageList.splice(index, 1);
                this.$emit('updateValue', this.imageList);
            }
        },
        resetImg() {
            this.$refs.inputFile.value = '';
            this.imgSrc = '';
        },
        changePicture(e) {
            if (!e.target) return;
            this.filesList = [].slice.call(e.target.files || e.dataTransfer.files)
            
            // this.fileData = a;
            // this.pictureName = a.name;
            // if (this.max) {
            //     if (a.size > this.max * 1024 * 1024) {
            //         return this.$message.error(`图片大小超过${this.max}M限制`);
            //     }
            // }
            this.uploadFile()
            // filesList.forEach(f => {
            //     console.log(f)
            //     this.createImage(f);
            // })
            //      this.createImage();
        },
        uploadFile() {
            const file = this.filesList.shift()
            this.createImage(file);
        },
        createImage(file) {
            let _data = new FormData();
            _data.append('file', file)

            upload(_data).then((res) => {
                const { img_url } = res.data;
                if (this.number === 1) {
                    this.imageList = [img_url];
                    this.$emit('updateValue', img_url);
                } else {
                    this.imageList.push(img_url)
                    this.$emit('updateValue', this.imageList);
                }

                if (this.filesList.length) {
                    this.uploadFile()
                }
            });
        },
        initValue() {
            if (
                Object.prototype.toString.call(this.value) === '[object String]'
            ) {
                this.imageList = [this.value];
            } else if (
                Object.prototype.toString.call(this.value) === '[object Array]'
            ) {
                this.imageList = this.value;
            } else if (Object.prototype.toString.call(this.value) === '[object Undefined]') {
                this.imageList = []
            }
        }
    },
    mounted() {
        this.initValue();
    }
};
</script>

<style lang="less">
.image-wrapper {
    display: flex;
    flex-wrap: wrap;
}
.upload-image {
    width: 150px;
    height: 150px;
    border: 1px dashed #999;
    border-radius: 8px;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin-top: 10px;
    &::hover {
        background: rgba(0, 0, 0, 0.5);
        color: black;
    }
}
.upload-input {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer;
}
.delete {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    text-align: center;
    line-height: 200px;
    color: white;
    z-index: 10;
    transition: all 0.12s linear;
    font-size: 20px;
    opacity: 0;
    font-weight: 700;
    border-radius: inherit;
    &:hover {
        background: rgba(0, 0, 0, 0.7);
        opacity: 1;
    }
}
</style>
